// extracted by mini-css-extract-plugin
export default {"filterTitle":"providerFilterPrice_filterTitle__zZKrq","priceAverageText":"providerFilterPrice_priceAverageText__sLVOF","price":"providerFilterPrice_price__0MlZ4"};